import React, { useState, FunctionComponent } from "react";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { Paper, Button, Grid, Typography, TextField } from "@material-ui/core";
import { Formik, Form, ErrorMessage } from "formik";
import * as yup from "yup";
import { SnackBar } from "../../SnackBar";
import { useTerminalsStyles } from "./useTerminalsStyles";
import { useStore } from "../../../store";
import FormControl from "@material-ui/core/FormControl";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";

const createSchema = yup.object().shape({
  name: yup.string().required("Name is required"),

  address: yup
    .string()
    .matches(
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
      {
        message: "Invalid ip address",
      }
    )
    .required("IpAddress is required"),

  db_port: yup
    .string()
    .matches(/^(0|[1-9]\d*)$/, {
      message: "Only numbers are allowed",
    })
    .max(6, "Maximum 6 digits!")
    .required("Port No is required"),

  db_name: yup.string().required("Database name is required"),

  db_user: yup.string().required("Database user is required"),

  db_secret: yup
    .string()
    .min(2, "Too Short!")
    .max(70, "Too Long!")
    .required("Password is required"),
});
const updateSchema = yup.object().shape({
  name: yup.string().required("Name is required"),

  address: yup
    .string()
    .matches(
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
      {
        message: "Invalid ip address",
      }
    )
    .required("IpAddress is required"),

  db_port: yup
    .string()
    .matches(/^(0|[1-9]\d*)$/, {
      message: "Only numbers are allowed",
    })
    .max(6, "Maximum 6 digits!")
    .required("Port No is required"),

  db_name: yup.string().required("Database name is required"),

  db_user: yup.string().required("Database user is required"),

  db_secret: yup
    .string()
    .min(2, "Too Short!")
    .max(70, "Too Long!")
    .required("Password is required"),

  status: yup.string().required("Status is required"),
});

type terminalParams = {
  terminalId: any;
  goBackToList: () => void;
};
export const TerminalForm: FunctionComponent<terminalParams> = ({
  terminalId,
  goBackToList,
}) => {
  const classes = useTerminalsStyles();
  const [status] = useStore("status");
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const [terminalStatus, setTerminalStatus] = useState<string>("");
  const [
    terminals,
    { createTerminal, getTerminals, updateTerminal },
  ] = useStore("terminals");
  const [addressAvailable, setAddressAvailable] = useState<any>(null);
  const [showPassword, setShowPassword] = useState(false);

  const statusOptions =
    status &&
    status.map((item: { [key: string]: any }) => ({
      value: item.id,
      label: item.description,
    }));
  const initialValues = {
    name: "",
    address: "",
    db_port: "",
    db_name: "",
    db_user: "",
    db_secret: "",

    status: "",
  };
console.log("terminals",terminals)
  if (terminals&&terminals.message!=="You are not authorized for this action") {
    if (terminals && terminals.find((i: any) => i.id === terminalId)) {
      const terminalDetails = terminals.find((i: any) => i.id === terminalId);
      const {
        name,
        address,
        db_port,
        db_name,
        db_user,
        db_secret,
        status,
      } = terminalDetails;
  
      initialValues.name = name;
      initialValues.address = address;
      initialValues.db_port = db_port;
      initialValues.db_name = db_name;
      initialValues.db_user = db_user;
      initialValues.db_secret = db_secret;
  
      initialValues.status = statusOptions.find(
        (item: any) => status === item.value
      );
    }
  }
  const checkAvailability = (value: any) => {
    const terminal_address_list =
      terminals && terminals !== undefined
        ? Object.values(terminals && terminals).map(
            (value: any) => value.address
          )
        : "";

    if (terminal_address_list.includes(value)) {
      setAddressAvailable(true);
    } else {
      setAddressAvailable(false);
    }
  };

  const updatedTerminal = async (values: any) => {
    try {
      const terminalUpdateData = {
        name: values.name,
        address: values.address,
        db_port: values.db_port,
        db_name: values.db_name,
        db_user: values.db_user,
        db_secret: values.db_secret,
        status: values.status.value,
      };
      await updateTerminal(terminalId, terminalUpdateData);
      getTerminals();
      setSnackbarColor("green");
      setTerminalStatus("Terminal successfully updated");
      setTimeout(() => {
        //setNavigateToTerminalTable(true);
        goBackToList();
      }, 2000);
    } catch (error) {
      if (addressAvailable) {
        setSnackbarColor("red");
        setTerminalStatus("Address already exist");
      } else {
        setSnackbarColor("red");
        setTerminalStatus(error.error);
      }
    }
  };
  const submitForm = async (values: any) => {
    try {
      if (terminalId === "new") {
        await createTerminal({
          name: values.name,
          address: values.address,
          db_port: values.db_port,
          db_name: values.db_name,
          db_user: values.db_user,
          db_secret: values.db_secret,
        });

        getTerminals();
        setSnackbarColor("green");
        setTerminalStatus("Terminal successfully created");
        setTimeout(() => {
          //setNavigateToTerminalTable(true);
          goBackToList();
        }, 2000);
      } else {
        await updatedTerminal(values);
      }
    } catch (error) {
      //checkAvailability(values.address);
      if (addressAvailable) {
        setSnackbarColor("red");
        setTerminalStatus("Address already exist");
      } else {
        setSnackbarColor("red");
        setTerminalStatus(error.error);
      }
    }
  };

  const onCloseSnackbar = () => {
    setTerminalStatus("");
  };
  const handleClickShowPassword = () => {
    setShowPassword(true);
  };
  const handleClickHidePassword = () => {
    setShowPassword(false);
  };
    return (
      <div>
        <SnackBar
          status={terminalStatus}
          onCloseError={onCloseSnackbar}
          color={snackbarColor}
        />
        <Grid container>
          {/* <Grid item>
          <Typography className={classes.userTitle}>
            {" "}
            {terminalId === "new"
              ? "Create Terminal"
              : "Edit Terminal"}
          </Typography>
        </Grid> */}
        </Grid>
        <Paper elevation={4} style={{ minHeight: "25em", minWidth: "50%" }}>
          <Grid container>
            <Grid item>
              <Formik
                enableReinitialize
                validationSchema={
                  terminalId === "new" ? createSchema : updateSchema
                }
                initialValues={initialValues}
                onSubmit={(values) => {
                  submitForm(values);
                }}
              >
                {({ values, handleChange, setFieldValue }) => (
                  <Form>
                    <Grid container direction="row">
                      <Grid item xs>
                        <Grid
                          container
                          spacing={5}
                          className={classes.fieldSpace}
                        >
                          <Grid item xs={6}>
                            <Typography className={classes.fieldLabelStyles}>
                              Terminal Name
                            </Typography>
                            <TextField
                              variant="outlined"
                              name="name"
                              value={values.name}
                              onChange={handleChange}
                              inputProps={{ maxLength: 50 }}
                              fullWidth={true}
                            />

                            <ErrorMessage name="name">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography className={classes.fieldLabelStyles}>
                              Address
                            </Typography>
                            <TextField
                              variant="outlined"
                              name="address"
                              value={values.address}
                              //onChange={handleChange}
                              onChange={(e) => {
                                handleChange(e);
                                const domain = e.target.value; //.replace(/.*@/, '')
                                setFieldValue("address", domain);
                                checkAvailability(domain);
                              }}
                              inputProps={{ maxLength: 50 }}
                              fullWidth={true}
                            />

                            <ErrorMessage name="address">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography className={classes.fieldLabelStyles}>
                              Database User
                            </Typography>
                            <TextField
                              variant="outlined"
                              name="db_user"
                              value={values.db_user}
                              onChange={handleChange}
                              inputProps={{ maxLength: 50 }}
                              fullWidth={true}
                            />

                            <ErrorMessage name="db_user">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography className={classes.fieldLabelStyles}>
                              Database Name
                            </Typography>
                            <TextField
                              variant="outlined"
                              name="db_name"
                              value={values.db_name}
                              onChange={handleChange}
                              inputProps={{ maxLength: 50 }}
                              fullWidth={true}
                            />

                            <ErrorMessage name="db_name">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </Grid>

                          <Grid item xs={6}>
                            <FormControl fullWidth={true}>
                              <Typography className={classes.fieldLabelStyles}>
                                Database Password
                              </Typography>
                              <OutlinedInput
                                name="db_secret"
                                type={showPassword ? "text" : "password"}
                                value={values.db_secret}
                                onChange={handleChange("db_secret")}
                                inputProps={{ maxLength: 50 }}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton
                                      aria-label="toggle password visibility"
                                      onClick={handleClickShowPassword}
                                      onMouseDown={handleClickHidePassword}
                                      edge="end"
                                    >
                                      {showPassword ? (
                                        <Visibility />
                                      ) : (
                                        <VisibilityOff />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                }
                                labelWidth={0}
                              />
                            </FormControl>
                            <ErrorMessage name="db_secret">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography className={classes.fieldLabelStyles}>
                              Database Port
                            </Typography>
                            <TextField
                              variant="outlined"
                              name="db_port"
                              value={values.db_port}
                              onChange={handleChange}
                              inputProps={{ maxLength: 50 }}
                              fullWidth={true}
                            />

                            <ErrorMessage name="db_port">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            style={{
                              display: terminalId === "new" ? "none" : "block",
                            }}
                          >
                            {/* <Typography>Status</Typography>
                          <Select
                            style={{ height: "2em" }}
                            onChange={(value: any) => {
                              setFieldValue("status", value);
                            }}
                            options={statusOptions}
                            value={values.status}
                            fullWidth={true}
                          ></Select>
                          <ErrorMessage name="status">
                            {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                          </ErrorMessage> */}
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            direction="row"
                            style={{
                              display: terminalId === "new" ? "none" : "block",
                            }}
                          >
                            <Grid
                              container
                              direction="row"
                              spacing={1}
                              justify="flex-end"
                              alignItems="flex-end"
                              className={classes.commonButtonPosition}
                            >
                              <Grid
                                item
                                xs={6}
                                sm="auto"
                                className={classes.commonButtonStyle}
                              >
                                <Button
                                  variant="contained"
                                  color="primary"
                                  type="reset"
                                  size="medium"
                                >
                                  <Typography>Clear</Typography>
                                </Button>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                sm="auto"
                                className={classes.commonButtonStyle}
                              >
                                <Button
                                  variant="contained"
                                  color="primary"
                                  type="submit"
                                  size="medium"
                                >
                                  <Typography>Submit</Typography>
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                          {/*create form button */}
                          <Grid item xs={6}></Grid>
                          <Grid
                            item
                            xs={6}
                            direction="row"
                            style={{
                              display: terminalId === "new" ? "block" : "none",
                            }}
                          >
                            <Grid
                              container
                              direction="row"
                              spacing={1}
                              justify="flex-end"
                              alignItems="center"
                              className={classes.commonButtonPosition}
                            >
                              <Grid
                                item
                                xs={6}
                                sm="auto"
                                className={classes.commonButtonStyle}
                              >
                                <Button
                                  variant="contained"
                                  color="primary"
                                  type="reset"
                                  size="medium"
                                >
                                  <Typography>Clear</Typography>
                                </Button>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                sm="auto"
                                className={classes.commonButtonStyle}
                              >
                                <Button
                                  variant="contained"
                                  color="primary"
                                  type="submit"
                                  size="medium"
                                >
                                  <Typography> Submit </Typography>
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Grid>
          </Grid>
        </Paper>
      </div>
    );
};
